import React from "react";

import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { FiscalizationItem } from "../BetDetailsModalFiscalization";

export const TransactionSignatureCounter = observer(
	function TransactionSignatureCounter(props: {
		firstFinishedTransaction: FiscalizationItem;
	}) {
		const { t } = useTranslation("mybets");

		const { firstFinishedTransaction } = props;
		return (
			<div className="bet__details__row table--bet__fiscalization__row">
				<div className="bet__details__col table--bet__fiscalization__data">
					{t("mybets:ITEM.ADDITIONAL_SIGNATURE_COUNTER")}:
				</div>
				<div className="bet__details__col table--bet__fiscalization__data">
					{firstFinishedTransaction.signatureCounter}
				</div>
			</div>
		);
	}
);
